import { BaseError } from './base';

export class InvalidParamError extends BaseError {
  constructor(message: string) {
    super({
      cause: null,
      code: 'invalid_param_error',
      docsUrl: null,
      name: 'InvalidParamError',
      shortMessage: message,
    });
  }
}
